import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Table from '../controls/table/table.jsx';
import { actionDevices } from '../../actions/devices_actions.jsx';

const Columns = [
    {
        header: "Devices.deviceImei",
        name: "deviceImei"
    },
    {
        header: "Devices.name",
        name: "name"
    },
    {
        header: "Devices.protocolType",
        name: "protocolType"
    },
    {
        header: "Devices.isActive",
        name: "isActive"
    }
];

class DeviceList extends React.Component {
    constructor(props) {
        super(props);
        this.getData = this.getData.bind(this);
        this.addDevice = this.addDevice.bind(this);
        this.editDevice = this.editDevice.bind(this);
    }
    
    componentDidMount() {
        this.getData();
    }
    
    getData(filter) {
        filter = filter ? filter : this.props.filter;
        this.props.getDevices(filter);
    }

    addDevice() {
        this.props.history.push('/devices/addDevice');
    }

    editDevice(device) {
        this.props.history.push('/devices/editDevice/' + device.deviceImei);
    }

    render() {
        return (
            <div>
                <Table settings={{
                    columns: Columns,
                    items: this.props.devices,
                    itemsFilter: this.props.filter,
                    isEditable: true,
                    getItemsFunction: this.getData,
                    addItemFunction: this.addDevice,
                    editItemFunction: this.editDevice
                }}/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        devices: state.devices.devices,
        filter: state.devices.filter,
        loading: state.devices.loading,
        errors: state.devices.errors,
        forceReload: state.devices.forceReload
    };
}

export default connect(
        mapStateToProps,
        dispatch => bindActionCreators(actionDevices, dispatch)
)(DeviceList);